module.exports = __webpack_public_path__ + "static/media/carousel7.1e4411dc.jpeg";